import trackerApi from '../../src/api/tracker';

export const loginNextStep =  (step)=>{
  return { type: 'NEXT_STEP' , payload: step};
};

export const counter = ()=>{
  return { type: 'COUNTER'  };
};


export const setPhoneNumber = (phone)=>{
  return { type: 'SET_PHONE' , payload: phone};
};

export const saveInfo = (info)=>{
  return { type: 'SAVE' , payload: info};
};

export const updateImageUri = (uri)=>{
  return { type: 'URI' , payload: uri};
};
